
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/ui-components/PageTitle/PageTitle.vue';

@Component({
  name: 'BranchesPage',
  components: {
    PageTitle
  },
})
export default class BranchesPage extends Vue {
  
}
